import gsap from 'gsap'
import { TweenMax, Power2 } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger)

export default function index(){
  if(document.getElementById('smokeEffect')){
    const particleSystem = new ParticleSystem('smokeEffect', 32, 50);
    particleSystem.init();
    particleSystem.start();
  }
  const spacer = document.getElementById('spacer')
  if(spacer){
    gsap.fromTo('.firstview .firstview__wrap',
      {},
      {
        opacity: 0,
        scrollTrigger: {
          trigger: spacer,
          start: "top top",
          end: "bottom top",
          scrub: 1,
          once: false,
          //markers: true
        }
      }
    )
  }
}

class Particle {
  constructor(context, canvasWidth, canvasHeight) {
    this.context = context;
    this.canvasWidth = canvasWidth;
    this.canvasHeight = canvasHeight;

    // 初期位置: 左下
    this.x = this.canvasWidth * 1.5;
    this.y = this.canvasHeight * 1.5;

    // 速度: 右上方向
    this.xVelocity = (Math.random() * 2 + 1.5); // X軸は右方向
    this.yVelocity = -(Math.random() * 2 + 1.5); // Y軸は上方向（負の値）

    this.currentopacity = .75;
    this.radius = 1;
    this.rotation = 0;
    this.image = new Image();
    this.image.src = "/images/common/smoke.png";
  }

  draw() {
    if (this.image) {
      var Offset = this.radius / -2;
      this.context.save();
      this.context.translate(this.x, this.y);
      this.context.globalAlpha = this.currentopacity;
      this.context.rotate(this.rotation);
      this.context.drawImage(this.image, Offset, Offset, this.radius, this.radius);
      this.context.restore();
    }
  }

  update(growth) {
    this.x += this.xVelocity;
    this.y += this.yVelocity;
    this.rotation += Math.PI / 36;
    this.radius += growth;
    //this.currentopacity -= .0005;

    // 画面外（右上を超えたら）リセット
    if (this.x > this.canvasWidth || this.y < 0) {
      this.reset();
    }
  }

  reset() {
    // もう一度左下から開始
    this.x = 0;
    this.y = this.canvasHeight * 1.5;
    this.xVelocity = Math.random() * 2 + 1.5; // X軸は右方向
    this.yVelocity = -(Math.random() * 2 + 1.5); // Y軸は上方向
    this.radius = 1;
  }
}

class ParticleSystem {
  constructor(canvasId, particleCount, targetFPS) {
    this.canvas = document.getElementById(canvasId);
    this.context = this.canvas.getContext('2d');
    this.canvasWidth = this.canvas.width;
    this.canvasHeight = this.canvas.height;
    this.particleCount = particleCount;
    this.targetFPS = targetFPS;
    this.particles = [];
    this.growth = 1.5;
  }

  init() {
    for (let i = 0; i < this.particleCount; i++) {
      this.addParticle();
    }
  }

  addParticle() {
    const particle = new Particle(this.context, this.canvasWidth, this.canvasHeight);
    this.particles.push(particle);
  }

  update() {
    this.particles.forEach((particle) => {
      particle.update(this.growth);
    });
  }

  draw() {
    this.context.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    this.particles.forEach((particle) => {
      particle.draw();
    });
  }

  start() {
    setInterval(() => {
      this.update();
      this.draw();
    }, 1000 / this.targetFPS);
  }
}